import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';

export default {
    data: () => ({
        searchClient: algoliasearch(
            process.env.MIX_ALGOLIA_APP_ID,
            process.env.MIX_ALGOLIA_API
        ),
    }),

    methods: {
        indicesToSuggestions(indices) {
            return indices.map(({ hits }) => ({ data: hits }));
        },
        getSuggestionValue(suggestion) {
            return suggestion.item.id_articolo
        },
    }
}